import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Utilities } from 'src/app/models/utilities';
import { CommentValidation } from 'src/app/models/validator';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})

export class CommentsComponent implements OnInit {
  modelForm: FormGroup;
  @Input() public cellAWbnumber: any;
  isFormSubmitted = false;
  CountReachedMsg = false;
  charCount: number;
  characterLimit = 250;
  currentCommentDate: any;

  constructor(
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService,
    private _fb: FormBuilder,
    private AWBService: AWBService,
    private utilities: Utilities,
    private titleService: Title
  ) {
    titleService.setTitle('Air Way Bill');
   }

  ngOnInit() {
    this.modelForm = this._fb.group({
      txtDateTime: [this.currentCommentDate, [Validators.required]],
      txtComment: [null, [Validators.required, Validators.maxLength(150)]],
    });
    
    this.getComment();
  }

  getComment() {
    try {
      this.AWBService.GetCommentByAwbNumber(this.cellAWbnumber).subscribe(res => {
        if (res && res.success) {
          let commentdate = this.utilities.FormatDateWithTime(0, res?.data[0]?.commentdate)?.dateTimeString;
          this.modelForm.get('txtDateTime').setValue(commentdate)
        }
      })
    } catch (err: any) {
      console.log("Error", err);
    }
  }

  countCharcter() {
    const comment = this.modelForm.get('txtComment').value;
    this.charCount = comment?.length;
    if (this.charCount >= this.characterLimit + 1) {
      this.modelForm.get('txtComment').setValidators([CommentValidation]);
      this.CountReachedMsg = true;
    } else {
      this.modelForm.get('txtComment').clearValidators();
      this.CountReachedMsg = false;
    }
    this.modelForm.get('txtComment').updateValueAndValidity();
  }

  addComment(): void {
    this.isFormSubmitted = true;
    try {
      if (this.modelForm.invalid) {
        return;
      }
      const reqObj = {
        awbnumber: this.cellAWbnumber,
        comment: this.modelForm.get('txtComment').value?.trim(),
        commentdate: this.modelForm.get('txtDateTime').value,
      }
      this.ngxLoaderService.start();
      this.AWBService.AddComment(reqObj).subscribe(res => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.activeModal.close('Save Click');
          this.appCoreService.showMessage('Comment Saved Successfully.', 'Success', 'success');
          this.modelForm.get('txtComment').reset();
        }
      });
    } catch (err) {
      this.ngxLoaderService.stop();
    }
  }
}
